import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import Header from '../../components/Header/Header';
import MobileFooterNav from '../../components/MobileFooterNav';
import { InventoryThumbZoneProvider } from '../../context/InventoryThumbZoneContext';
import { InventoryViewModeProvider } from '../../context/InventoryViewModeContext';
import { MobileGlobalSearchProvider } from '../../context/MobileGlobalSearchContext';
import Routes from '../routes/Routes';
import {
  mobileBottomChromePaddingBottom,
  mobileFooterNavMediaQuery,
} from '../../components/MobileFooterNav/MobileFooterNav.styles';

const $Main = styled.main<{ $isStockInventaireTabPage: boolean }>`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: ${({ $isStockInventaireTabPage }) =>
    $isStockInventaireTabPage ? '1rem 2rem 2rem' : '2rem'};

  @media ${mobileFooterNavMediaQuery} {
    padding: ${({ $isStockInventaireTabPage }) =>
      $isStockInventaireTabPage ? '1rem' : '1rem'};
    padding-bottom: ${mobileBottomChromePaddingBottom};
  }
`;

const Layout = () => {
  const location = useLocation();
  const isStockInventaireTabPage =
    location.pathname === '/stock' || location.pathname === '/inventaire';

  return (
    <MobileGlobalSearchProvider>
      <InventoryViewModeProvider>
        <InventoryThumbZoneProvider>
          <Header />
          <$Main $isStockInventaireTabPage={isStockInventaireTabPage}>
            <Routes />
          </$Main>
          <MobileFooterNav />
        </InventoryThumbZoneProvider>
      </InventoryViewModeProvider>
    </MobileGlobalSearchProvider>
  );
};

export default Layout;
